module.exports = __webpack_public_path__ + "img/stack-exchange.26af9bc1.svg";